import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Createmagic() {
  return (
    <section className="create_magic p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={8}
            lg={7}
            xl={7}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>
              SaaS Video Production: How We <span>Create Magic?</span>
            </h2>
            <p>
              Here’s a peek into how we create magic with our SaaS video
              production. The formula is simple: The process is specially
              designed to extract value for you, every step of the way. Check
              out the streamlined process below:
            </p>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="magic_main">
              <div className="create_magic_item">
                <div className="create_magic_head">
                  <h5>You</h5>
                </div>
                <p>
                  You as the client are invited to take active part in the
                  entire process. Our team keeps you connected to ensure that we
                  share the same vision throughout.
                </p>
              </div>
              <div className="create_magic_item">
                <div className="create_magic_head">
                  <h5>Creative Manager</h5>
                </div>
                <p>
                  Our creative manager is an integral part of the team. He
                  coordinates with you, and every other person on the team,
                  making sure the video delivers on your set marketing goals.
                </p>
              </div>
              <div className="create_magic_item">
                <div className="create_magic_head">
                  <h5>Scriptwriter</h5>
                </div>
                <p>
                  It all begins in the mind of the scriptwriters. They picture
                  the story of your SaaS success. They make it happen with their
                  creative spark for storytelling, and concise, yet compelling
                  copy.
                </p>
              </div>
              <div className="create_magic_item">
                <div className="create_magic_head">
                  <h5>Storyboard Artist</h5>
                </div>
                <p>
                  Now the imagination is put into a breathing canvas –
                  storyboard. Each frame answers for why your SaaS product is
                  the real deal. It’s a story that is meant to stay with your
                  prospects.
                </p>
              </div>
              <div className="create_magic_item">
                <div className="create_magic_head">
                  <h5>Illustrator</h5>
                </div>
                <p>
                  Here you meet the talented designers who’ll create artwork
                  that is not just consistent with your style, but it’s so good
                  that it elevates your branding game to the next level.
                </p>
              </div>
              <div className="create_magic_item">
                <div className="create_magic_head">
                  <h5>Animator</h5>
                </div>
                <p>
                  The animator is one who threads all static frames into a
                  dynamic movie. Everything you brainstormed with us, comes to
                  fruition here. Your imagination is finally an animated reality
                  now!
                </p>
              </div>
              <div className="create_magic_item">
                <div className="create_magic_head">
                  <h5>Sound Designer</h5>
                </div>
                <p>
                  Music is meant to light up the mood, and set the tone for your
                  SaaS explainer video. Our sound experts love to experiment,
                  and create something unique. Sound effects are sure to hook
                  your audience till the end.
                </p>
              </div>
              <div className="create_magic_item">
                <div className="create_magic_head">
                  <h5>Voiceover Artist</h5>
                </div>
                <p>
                  Time to humanize your SaaS explainer video. To do that our
                  SaaS video production team has a pool of the most gifted
                  voiceover artists. From native speakers, to artists of all
                  tones and style.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Createmagic;
